import React from 'react'
import type { NewsListPage, PromotionsListPage } from 'api/api.types'
import { NewsList } from 'components/PageElements/NewsList/NewsList'
import { Salons } from 'components/PageElements/Salons/Salons'
import styles from './NewsPage.module.scss'

type NewsPageProps = {
  page: NewsListPage | PromotionsListPage,
}

/** News list or promotions list */
export const NewsPage: React.FC<NewsPageProps> = ({ page }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{page.title}</h1>
    <div className={styles.news}>
      <NewsList promotions={page.template === 'promotions-list'} />
    </div>
    <Salons withCityTitle />
  </div>
)
